document.addEventListener('change', (event) => {
  if (event.target.id !== 'e_invoice_file') return;

  const filename = document.getElementById('e_invoice_filename');
  if (filename) {
    filename.textContent = event.target.files.length ? event.target.files[0].name : '';
  }
});
